import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import AppliesCell from './AppliesCell';

// Every version of a single-value threshold (a change from a month, a one-month override), for the screens that show
// one headline value. Shown only when there is more than one, so the common case stays as simple as it was.
const VersionsList = ({ rows, renderValue, valueLabel = 'Threshold', month }) => {
  if (!rows || rows.length < 2) return null;
  return (
    <>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 3, mb: 1 }}>Versions</Typography>
      <TableContainer sx={{ maxWidth: 620 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAF8F3' }}>
              <TableCell><strong>{valueLabel}</strong></TableCell>
              <TableCell><strong>Applies</strong></TableCell>
              <TableCell><strong>Active</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{renderValue(row)}</TableCell>
                <TableCell><AppliesCell row={row} month={month} /></TableCell>
                <TableCell>{row.is_active ? 'Yes' : 'Off'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default VersionsList;
